// The leading `@` is load-bearing: without it, `someone@notironsight.app` matches.
export const INTERNAL_EMAIL_DOMAIN = '@ironsight.app'

export interface InternalUserSignals {
  email: string | undefined
  isGlobalAdmin: boolean | undefined
}

/**
 * Whether this session is our own staff rather than a customer.
 *
 * Two independent signals, because neither covers the other: the global admin
 * claim catches support browsing a customer organization, and the email domain
 * catches staff dogfooding with an ordinary account in their own org.
 */
export function isInternalUser({ email, isGlobalAdmin }: InternalUserSignals): boolean {
  if (isGlobalAdmin === true) {
    return true
  }

  return email?.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN) === true
}
